export interface IPermission {
  key: string;
  module: string;
  feature: string;
  featureValue: string;
  actionType: IPermissionActionType[];
}
export enum IPermissionTableColumnType {
  All,
  CRED,
  View,
  ViewCreate,
  ViewUpdate,
  Authorize,
  Print,
}

export enum IPermissionActionType {
  View = "View",
  Add = "Add",
  Edit = "Edit",
  Delete = "Delete",
  Print = "Print",
  Authorize = "Authorize",
}
export interface IAllUserPermissionsData {
  module: string;
  columnsType: IPermissionTableColumnType;
  permissions: IPermission[];
  disable?: boolean;
}

export const actionTypeAll = [
  IPermissionActionType.View,
  IPermissionActionType.Add,
  IPermissionActionType.Edit,
  IPermissionActionType.Delete,
  IPermissionActionType.Print,
  IPermissionActionType.Authorize,
];

export const actionTypeViewAndPrint = [
  IPermissionActionType.View,
  IPermissionActionType.Print,
];

export const actionTypeViewAndAdd = [
  IPermissionActionType.View,
  IPermissionActionType.Add,
];

export const actionTypeViewAndEdit = [
  IPermissionActionType.View,
  IPermissionActionType.Edit,
];

export const actionTypeCRED = [
  IPermissionActionType.View,
  IPermissionActionType.Add,
  IPermissionActionType.Edit,
  IPermissionActionType.Delete,
];

//======================== User Permissions Module Wise Data ========================//

// Dashboard Permissions
export const dashboardPermissions: IPermission[] = [
  {
    key: "D1",
    module: "Dashboard",
    feature: "Dashboard",
    featureValue: "Dashboard",
    actionType: [IPermissionActionType.View],
  },
];

// Vouchers Premissions
export const salesVouchersPermissions: IPermission[] = [
  {
    key: "VSI1",
    module: "Sales",
    // module: "Voucher",
    feature: "Invoice",
    featureValue: "Voucher.Sales.1",
    actionType: actionTypeAll,
  },
  {
    key: "VSP2",
    module: "Sales",
    // module: "Voucher",
    feature: "Proforma Invoice",
    featureValue: "Voucher.Sales.2",
    actionType: actionTypeAll,
  },
  {
    key: "VSC3",
    module: "Sales",
    // module: "Voucher",
    feature: "Credit Note",
    featureValue: "Voucher.Sales.3",
    actionType: actionTypeAll,
  },
  {
    key: "VSR4",
    module: "Sales",
    // module: "Voucher",
    feature: "Receipt",
    featureValue: "Voucher.Sales.5",
    actionType: actionTypeAll,
  },
  {
    key: "VSE5",
    module: "Sales",
    // module: "Voucher",
    feature: "Estimate",
    featureValue: "Voucher.Sales.4",
    actionType: actionTypeAll,
  },
  {
    key: "VSO6",
    module: "Sales",
    // module: "Voucher",
    feature: "Sales Order",
    featureValue: "Voucher.Sales.6",
    actionType: actionTypeAll,
  },
];

export const purchaseVouchersPermissions: IPermission[] = [
  {
    key: "VPB1",
    module: "Purchase",
    // module: "Voucher",
    feature: "Purchase Bill",
    featureValue: "Voucher.Purchase.7",
    actionType: actionTypeAll,
  },
  {
    key: "VPD2",
    module: "Purchase",
    // module: "Voucher",
    feature: "Debit Note",
    featureValue: "Voucher.Purchase.8",
    actionType: actionTypeAll,
  },
  {
    key: "VPP3",
    module: "Purchase",
    // module: "Voucher",
    feature: "Payment Out",
    featureValue: "Voucher.Purchase.10",
    actionType: actionTypeAll,
  },
  {
    key: "VPO4",
    module: "Purchase",
    // module: "Voucher",
    feature: "Purchase Order",
    featureValue: "Voucher.Purchase.9",
    actionType: actionTypeAll,
  },
];

export const expensesPermissions: IPermission[] = [
  {
    key: "VE1",
    module: "Expenses",
    feature: "Expenses",
    featureValue: "Voucher.Expenses.14",
    actionType: actionTypeAll,
  },
];

export const IncomePermissions: IPermission[] = [
  {
    key: "VI1",
    module: "Income",
    feature: "Income",
    featureValue: "Voucher.Income.15",
    actionType: actionTypeAll,
  },
];

export const ContraPermissions: IPermission[] = [
  {
    key: "VC1",
    module: "Contra",
    feature: "Contra",
    featureValue: "Voucher.Contra.13",
    actionType: actionTypeAll,
  },
];

export const JournalPermissions: IPermission[] = [
  {
    key: "VJ1",
    module: "Journal",
    feature: "Journal",
    featureValue: "Voucher.Journal.12",
    actionType: actionTypeAll,
  },
];

export const FixedAssetPermissions: IPermission[] = [
  {
    key: "VFA1",
    module: "Asset",
    feature: "Fixed Asset",
    featureValue: "Voucher.Asset.11",
    actionType: actionTypeAll,
  },
];

// Report Premissions

export const RepostPermissions: IPermission[] = [
  {
    key: "RB1",
    module: "Report",
    feature: "Balance Sheet",
    featureValue: "Report.BalanceSheet",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RP2",
    module: "Report",
    feature: "Profit and Loss",
    featureValue: "Report.P&L",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RT3",
    module: "Report",
    feature: "Trial Balance",
    featureValue: "Report.TrialBalance",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RC4",
    module: "Report",
    feature: "Cash Flow",
    featureValue: "Report.CashFlow",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RD5",
    module: "Report",
    feature: "Debtors Ageing",
    featureValue: "Report.DebtorsAgeing",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RC6",
    module: "Report",
    feature: "Creditors Ageing",
    featureValue: "Report.CreditorsAgeing",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RO7",
    module: "Report",
    feature: "Customer Outstanding",
    featureValue: "Report.CustomerOutstanding",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RS8",
    module: "Report",
    feature: "Supplier Outstanding",
    featureValue: "Report.SupplierOutstanding",
    actionType: actionTypeViewAndPrint,
  },

  {
    key: "RG9",
    module: "Report",
    feature: "General Ledger",
    featureValue: "Report.GeneralLedger",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RF10",
    module: "Report",
    feature: "Fixed Assets Register",
    featureValue: "Report.FixedAssets",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RB11",
    module: "Report",
    feature: "Bank Reconciliation",
    featureValue: "Report.BankReconciliation",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RG12",
    module: "Report",
    feature: "GST",
    featureValue: "Report.GST",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RT13",
    module: "Report",
    feature: "TDS",
    featureValue: "Report.Tds",
    actionType: actionTypeViewAndPrint,
  },
  {
    key: "RT14",
    module: "Report",
    feature: "TCS",
    featureValue: "Report.Tcs",
    actionType: actionTypeViewAndPrint,
  },
];

// Master Premissions
export const ClientPremissions: IPermission[] = [
  {
    key: "MC1",
    module: "Client",
    feature: "Client",
    featureValue: "Master.Client",
    actionType: actionTypeAll,
  },
];

export const LedgerPermissions: IPermission[] = [
  {
    key: "MLL1",
    module: "Ledger",
    feature: "Ledger",
    featureValue: "Master.Ledger",
    actionType: actionTypeAll,
  },
  {
    key: "MLP2",
    module: "Ledger",
    feature: "Party Ledger",
    featureValue: "Master.Ledger.Party",
    actionType: actionTypeAll,
  },
  {
    key: "MLS10",
    module: "Ledger",
    feature: "Sales Ledger",
    featureValue: "Master.Ledger.Sales",
    actionType: actionTypeAll,
  },
  {
    key: "MLP11",
    module: "Ledger",
    feature: "Purchase Ledger",
    featureValue: "Master.Ledger.Purchase",
    actionType: actionTypeAll,
  },
  {
    key: "MLC3",
    module: "Ledger",
    feature: "Customer Ledger",
    featureValue: "Master.Ledger.Customer",
    actionType: actionTypeAll,
  },
  {
    key: "MLS4",
    module: "Ledger",
    feature: "Suppliers Ledger",
    featureValue: "Master.Ledger.Suppliers",
    actionType: actionTypeAll,
  },
  {
    key: "MLE5",
    module: "Ledger",
    feature: "Expenses Ledger",
    featureValue: "Master.Ledger.Expenses",
    actionType: actionTypeAll,
  },
  {
    key: "MLI6",
    module: "Ledger",
    feature: "Income Ledger",
    featureValue: "Master.Ledger.Income",
    actionType: actionTypeAll,
  },
  {
    key: "MLB7",
    module: "Ledger",
    feature: "Bank Ledger",
    featureValue: "Master.Ledger.Bank",
    actionType: actionTypeAll,
  },
  {
    key: "MLC8",
    module: "Ledger",
    feature: "Cash Ledger",
    featureValue: "Master.Ledger.Cash",
    actionType: actionTypeAll,
  },
  {
    key: "MLA9",
    module: "Ledger",
    feature: "Assets Ledger",
    featureValue: "Master.Ledger.Assets",
    actionType: actionTypeAll,
  },
];

export const GroupPermissions: IPermission[] = [
  {
    key: "MGG1",
    module: "Group",
    feature: "Group",
    featureValue: "Master.Group",
    actionType: actionTypeAll,
  },
  {
    key: "MGP2",
    module: "Group",
    feature: "Party Group",
    featureValue: "Master.Group.Party",
    actionType: actionTypeAll,
  },
  {
    key: "MGS10",
    module: "Group",
    feature: "Sales Group",
    featureValue: "Master.Group.Sales",
    actionType: actionTypeAll,
  },
  {
    key: "MGP11",
    module: "Group",
    feature: "Purchase Group",
    featureValue: "Master.Group.Purchase",
    actionType: actionTypeAll,
  },
  {
    key: "MGC3",
    module: "Group",
    feature: "Customer Group",
    featureValue: "Master.Group.Customer",
    actionType: actionTypeAll,
  },
  {
    key: "MGS4",
    module: "Group",
    feature: "Suppliers Group",
    featureValue: "Master.Group.Suppliers",
    actionType: actionTypeAll,
  },
  {
    key: "MGE5",
    module: "Group",
    feature: "Expenses Group",
    featureValue: "Master.Group.Expenses",
    actionType: actionTypeAll,
  },
  {
    key: "MGI6",
    module: "Group",
    feature: "Income Group",
    featureValue: "Master.Group.Income",
    actionType: actionTypeAll,
  },

  {
    key: "MGB7",
    module: "Group",
    feature: "Bank Group",
    featureValue: "Master.Group.Bank",
    actionType: actionTypeAll,
  },
  {
    key: "MGC8",
    module: "Group",
    feature: "Cash Group",
    featureValue: "Master.Group.Cash",
    actionType: actionTypeAll,
  },
  {
    key: "MGA9",
    module: "Group",
    feature: "Assets Group",
    featureValue: "Master.Group.Assets",
    actionType: actionTypeAll,
  },
];

export const ItemPermissions: IPermission[] = [
  {
    key: "MII1",
    module: "Item",
    feature: "Item",
    featureValue: "Master.Item",
    actionType: actionTypeAll,
  },
  {
    key: "MIC2",
    module: "Item",
    feature: "Item Category",
    featureValue: "Master.Item.Category",
    actionType: actionTypeAll,
  },
  {
    key: "MIU3",
    module: "Item",
    feature: "Unit",
    featureValue: "Master.Item.Unit",
    actionType: actionTypeAll,
  },
  {
    key: "MIL4",
    module: "Item",
    feature: "ItemLocations",
    featureValue: "Master.Item.Locations",
    actionType: actionTypeAll,
  },
];

export const BankReconciliationPermissions: IPermission[] = [
  {
    key: "MBR1",
    module: "BankReconciliation",
    feature: "Bank Reconciliation",
    featureValue: "Master.BankReconciliation",
    actionType: actionTypeViewAndAdd,
  },
];

export const ChequePermissions: IPermission[] = [
  {
    key: "MCC1",
    module: "Cheque",
    feature: "Cheque",
    featureValue: "Master.Cheque",
    actionType: actionTypeCRED,
  },
];

export const LoanAccountPermissions: IPermission[] = [
  {
    key: "MLA1",
    module: "LoanAccount",
    feature: "Loan Account",
    featureValue: "Master.LoanAccount",
    actionType: actionTypeCRED,
  },
];

// export const AssetsPermissions: IPermission[] = [
//   {
//     key: "MAD1",
//     module: "Assets",
//     feature: "Disposed",
//     featureValue: "Master.Assets.Disposed",
//     actionType: actionTypeAll,
//   },
//   {
//     key: "MAL2",
//     module: "Assets",
//     feature: "Location",
//     featureValue: "Master.Assets.Location",
//     actionType: actionTypeAll,
//   },
// ];

export const AssetsLocationPermissions: IPermission[] = [
  {
    key: "VDA1",
    module: "Asset",
    feature: "Disposed Asset",
    featureValue: "Voucher.Asset.DisposedAsset",
    actionType: actionTypeAll,
  },
  {
    key: "MAL1",
    module: "AssestsLocation",
    feature: "Assests Location",
    featureValue: "Master.AssestsLocation",
    actionType: actionTypeCRED,
  },
];

// Setting Premissions
export const SettingCompanyInfoPermissions: IPermission[] = [
  {
    key: "SCI1",
    module: "SettingCompany",
    feature: "Company Information",
    featureValue: "Setting.Company.Info",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SCD2",
    module: "SettingCompany",
    feature: "Contact Details",
    featureValue: "Setting.Company.Details",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SCP3",
    module: "SettingCompany",
    feature: "Payment Term",
    featureValue: "Setting.Company.PaymentTerm",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SCG4",
    module: "SettingCompany",
    feature: "GST",
    featureValue: "Setting.Company.GST",
    actionType: actionTypeViewAndEdit,
  },
];

export const SettingVouchersPermissions: IPermission[] = [
  {
    key: "SVS1",
    module: "Setting",
    feature: "Sales Setting",
    featureValue: "Setting.Voucher.1",
    actionType: actionTypeCRED,
  },
  {
    key: "SVP2",
    module: "Setting",
    feature: "Proforma Invoice Setting",
    featureValue: "Setting.Voucher.2",
    actionType: actionTypeCRED,
  },
  {
    key: "SVC3",
    module: "Setting",
    feature: "Credit Note Setting",
    featureValue: "Setting.Voucher.3",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SVR4",
    module: "Setting",
    feature: "Receipt Setting",
    featureValue: "Setting.Voucher.5",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SVE5",
    module: "Setting",
    feature: "Estimate Setting",
    featureValue: "Setting.Voucher.4",
    actionType: actionTypeCRED,
  },
  {
    key: "SVO6",
    module: "Setting",
    feature: "Sales Order Setting",
    featureValue: "Setting.Voucher.6",
    actionType: actionTypeCRED,
  },
  // Purchase Setting
  {
    key: "SVP7",
    module: "Setting",
    feature: "Purchase Bill Setting",
    featureValue: "Setting.Voucher.7",
    actionType: actionTypeCRED,
  },
  {
    key: "SVS8",
    module: "Setting",
    feature: "Debit Note Setting",
    featureValue: "Setting.Voucher.8",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SVS9",
    module: "Setting",
    feature: "Payment Out Setting",
    featureValue: "Setting.Voucher.10",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SVO10",
    module: "Setting",
    feature: "Purchase Order",
    featureValue: "Setting.Voucher.9",
    actionType: actionTypeCRED,
  },
  {
    key: "SVE11",
    module: "Setting",
    feature: "Expenses Setting",
    featureValue: "Setting.Voucher.14",
    actionType: actionTypeCRED,
  },
  {
    key: "SVI12",
    module: "Setting",
    feature: "Income Setting",
    featureValue: "Setting.Voucher.15",
    actionType: actionTypeCRED,
  },
  {
    key: "SVC13",
    module: "Setting",
    feature: "Contra Setting",
    featureValue: "Setting.Voucher.13",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SVJ14",
    module: "Setting",
    feature: "Journal Setting",
    featureValue: "Setting.Voucher.12",
    actionType: actionTypeViewAndEdit,
  },
  {
    key: "SVF15",
    module: "Setting",
    feature: "Fixed Asset Setting",
    featureValue: "Setting.Voucher.11",
    actionType: actionTypeViewAndEdit,
  },
];

export const SettingItemPermissions: IPermission[] = [
  {
    key: "SI1",
    module: "Setting",
    feature: "Item Setting",
    featureValue: "Setting.Item",
    actionType: actionTypeViewAndEdit,
  },
];

export const SettingOpeningBalancePermissions: IPermission[] = [
  {
    key: "SO1",
    module: "Setting",
    feature: "Opening Balance",
    featureValue: "Setting.OpeningBalance",
    actionType: actionTypeCRED,
  },
];

export const SettingTemplatesPermissions: IPermission[] = [
  {
    key: "ST1",
    module: "Setting",
    feature: "Templates",
    featureValue: "Setting.Templates",
    actionType: actionTypeViewAndEdit,
  },
];

export const SettingDefaultLedgerPermissions: IPermission[] = [
  {
    key: "SD1",
    module: "Setting",
    feature: "Default Ledger",
    featureValue: "Setting.DefaultLedger",
    actionType: actionTypeViewAndEdit,
  },
];

export const SettingTermsAndConditionsPermissions: IPermission[] = [
  {
    key: "STS1",
    module: "Setting",
    feature: "Sales T&C",
    featureValue: "Setting.TC.1",
    actionType: actionTypeCRED,
  },
  {
    key: "STP2",
    module: "Setting",
    feature: "Proforma Invoice T&C",
    featureValue: "Setting.TC.2",
    actionType: actionTypeCRED,
  },
  {
    key: "STC3",
    module: "Setting",
    feature: "Credit Note T&C",
    featureValue: "Setting.TC.3",
    actionType: actionTypeCRED,
  },
  {
    key: "STR4",
    module: "Setting",
    feature: "Receipt T&C",
    featureValue: "Setting.TC.5",
    actionType: actionTypeCRED,
  },
  {
    key: "STE5",
    module: "Setting",
    feature: "Estimate T&C",
    featureValue: "Setting.TC.4",
    actionType: actionTypeCRED,
  },
  {
    key: "STO6",
    module: "Setting",
    feature: "Sales Order T&C",
    featureValue: "Setting.TC.6",
    actionType: actionTypeCRED,
  },
  // Purchase Setting
  {
    key: "STP7",
    module: "Setting",
    feature: "Purchase Bill T&C",
    featureValue: "Setting.TC.7",
    actionType: actionTypeCRED,
  },
  {
    key: "STD8",
    module: "Setting",
    feature: "Debit Note T&C",
    featureValue: "Setting.TC.8",
    actionType: actionTypeCRED,
  },
  {
    key: "STP9",
    module: "Setting",
    feature: "Payment Out T&C",
    featureValue: "Setting.TC.10",
    actionType: actionTypeCRED,
  },
  {
    key: "STB10",
    module: "Setting",
    feature: "Purchase T&C",
    featureValue: "Setting.TC.9",
    actionType: actionTypeCRED,
  },
  {
    key: "STE11",
    module: "Setting",
    feature: "Expenses T&C",
    featureValue: "Setting.TC.14",
    actionType: actionTypeCRED,
  },
  {
    key: "STI12",
    module: "Setting",
    feature: "Income T&C",
    featureValue: "Setting.TC.15",
    actionType: actionTypeCRED,
  },
  {
    key: "STC13",
    module: "Setting",
    feature: "Contra T&C",
    featureValue: "Setting.TC.13",
    actionType: actionTypeCRED,
  },
  {
    key: "STJ14",
    module: "Setting",
    feature: "Journal T&C",
    featureValue: "Setting.TC.12",
    actionType: actionTypeCRED,
  },
  {
    key: "STF15",
    module: "Setting",
    feature: "Fixed Asset T&C",
    featureValue: "Setting.TC.11",
    actionType: actionTypeCRED,
  },
];

export const SettingTDSPermissions: IPermission[] = [
  {
    key: "STD1",
    module: "Setting",
    feature: "TDS",
    featureValue: "Setting.TDS",
    actionType: actionTypeCRED,
  },
];

export const SettingTCSPermissions: IPermission[] = [
  {
    key: "STC1",
    module: "Setting",
    feature: "TCS",
    featureValue: "Setting.TCS",
    actionType: actionTypeCRED,
  },
];

export const SettingCurrenciesPermissions: IPermission[] = [
  {
    key: "SC1",
    module: "Setting",
    feature: "Currencies",
    featureValue: "Setting.Currencies",
    actionType: actionTypeCRED,
  },
];

export const SettingEmailPermissions: IPermission[] = [
  {
    key: "SE1",
    module: "Setting",
    feature: "Email",
    featureValue: "Setting.Email",
    actionType: actionTypeCRED,
  },
];

export const SettingLockMonthPermissions: IPermission[] = [
  {
    key: "SL1",
    module: "Setting",
    feature: "Lock Month",
    featureValue: "Setting.LockMonth",
    actionType: actionTypeCRED,
  },
];

// ----------------------- All Tabs -----------------------------
// Dashboard Tabs
export const dashboardTabs = [
  {
    module: "Dashboard",
    columnsType: IPermissionTableColumnType.View,
    permissions: dashboardPermissions,
  },
];

// All Customer Roles Vouchers Tabs

export const allCustomerRolesVouchersTabs = [
  {
    module: "Sales Vouchers",
    columnsType: IPermissionTableColumnType.All,
    permissions: salesVouchersPermissions,
  },
  {
    module: "Purchase Vouchers",
    columnsType: IPermissionTableColumnType.All,
    permissions: purchaseVouchersPermissions,
  },
  {
    module: "Expenses",
    columnsType: IPermissionTableColumnType.All,
    permissions: expensesPermissions,
  },
  {
    module: "Income",
    columnsType: IPermissionTableColumnType.All,
    permissions: IncomePermissions,
  },
  {
    module: "Contra",
    columnsType: IPermissionTableColumnType.All,
    permissions: ContraPermissions,
  },
  {
    module: "Journal",
    columnsType: IPermissionTableColumnType.All,
    permissions: JournalPermissions,
  },
  {
    module: "Fixed Assets",
    columnsType: IPermissionTableColumnType.All,
    permissions: FixedAssetPermissions,
  },
];

// report tabs
export const reportTabs = [
  {
    module: "Report Tabs",
    columnsType: IPermissionTableColumnType.Print,
    permissions: RepostPermissions,
  },
];

// master tabs
export const masterTabs = [
  {
    module: "Master Client",
    columnsType: IPermissionTableColumnType.All,
    permissions: ClientPremissions,
    // disable: true,
  },
  {
    module: "Master Ledger",
    columnsType: IPermissionTableColumnType.All,
    permissions: LedgerPermissions,
  },
  {
    module: "Master Group",
    columnsType: IPermissionTableColumnType.All,
    permissions: GroupPermissions,
  },
  {
    module: "Master Item",
    columnsType: IPermissionTableColumnType.All,
    permissions: ItemPermissions,
  },
  {
    module: "Master Bank Reconciliation",
    columnsType: IPermissionTableColumnType.ViewCreate,
    permissions: BankReconciliationPermissions,
  },
  {
    module: "Master Cheque",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: ChequePermissions,
  },
  {
    module: "Master Loan Account",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: LoanAccountPermissions,
  },
  {
    module: "Master Assets",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: AssetsLocationPermissions,
  },
];

// setting tabs
// (1) Setting Company Tabs
export const settingCompanyTabs = [
  {
    module: "Company Info",
    columnsType: IPermissionTableColumnType.ViewUpdate,
    permissions: SettingCompanyInfoPermissions,
  },
];

// (2) Setting Vouchers Setting Tabs
export const settingVouchersTabs = [
  {
    module: "Vouchers Setting",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingVouchersPermissions,
  },
];

// (3) Setting Item Setting Tabs
export const settingItemsTabs = [
  {
    module: "Item Setting",
    columnsType: IPermissionTableColumnType.ViewUpdate,
    permissions: SettingItemPermissions,
  },
];

// (4) Setting Opening Balance Tabs
export const settingOpeningBalanceTabs = [
  {
    module: "Opening Balance",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingOpeningBalancePermissions,
  },
];

// (5) Setting Templates Tabs
export const settingTemplatesTabs = [
  {
    module: "Templates",
    columnsType: IPermissionTableColumnType.ViewUpdate,
    permissions: SettingTemplatesPermissions,
  },
];

// (6) Setting Default Ledge Tabs
export const settingDefaultLedgeTabs = [
  {
    module: "Default Ledger",
    columnsType: IPermissionTableColumnType.ViewUpdate,
    permissions: SettingDefaultLedgerPermissions,
  },
];

// (7) Setting Terms And Conditions Tabs
export const settingTermsAndConditionsTabs = [
  {
    module: "Terms And Conditions",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingTermsAndConditionsPermissions,
  },
];

// (8) Setting Tds Tabs
export const settingTDSTabs = [
  {
    module: "TDS",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingTDSPermissions,
  },
];

// (9) Setting Tds Tabs
export const settingTCSTabs = [
  {
    module: "TCS",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingTCSPermissions,
  },
];

// (10) Currencies tabs;
export const settingCurrenciesTabs = [
  {
    module: "Currencies",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingCurrenciesPermissions,
  },
];
// (11) Currencies tabs;
export const settingEmailTabs = [
  {
    module: "Email",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingEmailPermissions,
  },
];

// (12) Lock Month
export const settingLockMonthTabs = [
  {
    module: "Lock Month",
    columnsType: IPermissionTableColumnType.CRED,
    permissions: SettingLockMonthPermissions,
  },
];

// All User Permissions

export const allUserPermissionsData: IAllUserPermissionsData[] = [
  // Dashboard Tabs
  ...dashboardTabs,
  // Vouchers
  ...allCustomerRolesVouchersTabs,
  // Report Tabs
  ...reportTabs,
  // Master Tabs
  ...masterTabs,
  // Setting Tabs
  ...settingCompanyTabs,
  ...settingVouchersTabs,
  ...settingItemsTabs,
  ...settingOpeningBalanceTabs,
  ...settingTemplatesTabs,
  ...settingDefaultLedgeTabs,
  ...settingTermsAndConditionsTabs,
  ...settingTDSTabs,
  ...settingTCSTabs,
  ...settingCurrenciesTabs,
  ...settingEmailTabs,
  ...settingLockMonthTabs,
];
